export const ArLocale = {
    page: {
        txtTitle: 'SHIRITORI | تعلّم مفردات اليابانية عبر الإنترنت بسهولة مع لعبة しらとり الممتعة',
    },
    common: {
        txtLogoAlt: 'قطار كابوس',
    },
    header: {
        txtLeave: 'مغادرة اللعبة',
    },
    dialog: {
        leave: {
            txtTitle: 'هل تريد مغادرة هذه اللعبة؟',
            btnStay: 'البقاء في اللعبة',
            btnLeave: 'المغادرة والاستسلام',
        },
    },
    home: {
        btnNewGame: 'لعبة جديدة',
        btnMainMenu: 'القائمة الرئيسية',
        btnJoinGame: 'انضمام',
        btnReturnToGame: 'العودة إلى اللعبة',
    },
    create: {
        headingNamePrompt: 'بأي اسم نناديك؟',
        placeholderName: 'اسمك',
        btnOk: 'موافق',
    },
    join: {
        placeholderName: 'اسمك',
        placeholderGameId: 'معرّف اللعبة',
        btnJoinGame: 'انضمام',
    },
    configure: {
        header: 'إعدادات اللعبة',
        labelExpectedPlayers: 'عدد اللاعبين',
        labelBoardSize: 'حجم اللوحة',
        labelWordList: 'قائمة الكلمات',
        labelAllowHints: 'السماح بالتلميحات',
        labelTurnTimer: 'مؤقّت الدور',
        optionNoTimer: 'بدون مؤقّت',
        optionTimer: 'مؤقّت',
        unitSeconds: 'ث',
        btnStartGame: 'ابدأ',
        toastCreateError: 'خطأ: لا يمكن إنشاء هذه اللعبة',
        toastTryAgain: 'خطأ: يُرجى المحاولة مرة أخرى لاحقًا.',
    },
    game: {
        lobby: {
            btnReady: 'جاهز',
            txtShareInvite: 'شارك هذا الرمز مع أصدقائك!',
            txtPlayer: 'لاعب',
            txtTeam: 'فريق',
        },
        message: {
            noSuchGame: 'هذه اللعبة غير موجودة',
            txtLoading: 'جارٍ التحميل...',
            txtCannotJoin: 'تعذّر الانضمام إلى اللعبة',
        },
        gameplay: {
            board: {
                timeoutTitle: 'الوقت',
                timeoutSubtitle: 'انتهى',
            },
            wordSearch: {
                multipleMatches: 'تم العثور على عدة تطابقات!',
                yourTurn: 'دورك الآن',
                placeholder: 'ما الكلمة التي سنلعبها؟',
                playAction: 'العب',
                timerSeconds: '{{seconds}}ث',
                toastNoSuchWord: 'لا توجد كلمة كهذه!',
                toastCantPlay: 'لا يمكنك لعب هذه الكلمة!',
                toastPlayed: 'تم لعب "{{word}}"',
                toastPlayFailed: 'عذرًا، تعذّر لعب هذه الكلمة!',
                validation: {
                    syllableMismatch: 'المقطع الافتتاحي لا يطابق المطلوب',
                    missingLastWord: 'الدور السابق لا يحتوي على كلمة',
                    wordNotInList: 'الكلمة ليست ضمن القائمة المحددة',
                }
            },
            spectate: {
                waitingOn: 'بانتظار {{player}}',
                timeLeft: 'الوقت المتبقي: {{seconds}}ث',
            },
            endGame: {
                header: 'انتهت اللعبة',
                viewResults: 'عرض النتائج',
                statsTotalTime: 'إجمالي وقت اللعب',
                statsSquaresFilled: 'الخانات المعبأة',
                statsLongestWord: 'أطول كلمة',
                share: 'مشاركة',
                sharing: 'جارٍ المشاركة...',
                ariaCloseLabel: 'إغلاق نافذة نهاية اللعبة',
            }
        },
    },
    footer: {
        linkHowToPlay: 'طريقة اللعب',
        linkPrivacyPolicy: 'سياسة الخصوصية',
        txtAllRightsReserved: 'جميع الحقوق محفوظة.',
    },
    howToPlay: {
        title: 'كيفية لعب Shiritori しりとり (shiritori)',
        btnPlayNow: 'العب الآن!',
        btnReturnToGame: 'العودة إلى اللعبة:',
        description1: 'b|Shiritori| هي نسختنا الجماعية عبر الإنترنت من لعبة سلسلة الكلمات اليابانية しりとり. ابنِ لوحة صور أثناء تدريب المفردات مع الأصدقاء أو بمفردك.',
        description2: 'أنشئ لعبة أو انضم إلى واحدة، واختر حجم اللوحة ومجموعة الصور وقائمة الكلمات، ثم تسابقوا لملء الشبكة بكلمات صحيحة قبل أن يخطئ أحد.',
        gameSetup: {
            title: 'إنشاء لعبة أو الانضمام إليها',
            p1: 'ابدأ لاعبًا واحدًا أو ادعُ حتى 9 أصدقاء (10 لاعبين إجمالًا) عبر رابط قابل للمشاركة أو رمز اللعبة.',
            p2: 'اختر ما تريد: حجم اللوحة (3x3 أو 5x5 أو 7x7)، نمط/لون الخلفية، مجموعة الصور، وقائمة الكلمات المراد دراستها.',
            p3: 'يفتح الأصدقاء الرابط، يختارون اسمًا مستعارًا، ويظهرون في الردهة؛ تبدأ اللعبة عندما ينضم العدد المتوقع من اللاعبين.',
            p4: 'يمكن للمنضمين المتأخرين مشاهدة مباراة جارية في وضع المشاهدة فقط.',
        },
        objective: {
            title: 'الهدف',
            p1: 'اربط الكلمات بحيث تبدأ كل كلمة جديدة بالمقطع الأخير من الكلمة السابقة، واملأ اللوحة، ولا تنهِ أي كلمة بالحرف ん.',
        },
        wordRules: {
            title: 'الكلمات الصحيحة',
            p1: 'اكتب بالكانا أو بالرومـاجي؛ يتم تحويل الرومـاجي إلى هيراغانا على جهة العميل قبل التحقق.',
            p2: 'يجب أن تكون الكلمات ضمن القائمة المختارة (100/1000 الأكثر شيوعًا، الأطعمة، الرياضة، إلخ) وتظهر معانيها بعد لعبها.',
            p3: 'الكلمات المستخدمة مسبقًا تُحظر. وإذا كانت المتجانسات الصوتية مسموحة، يمكنك اختيار صيغة غير مستخدمة مع الصورة الصحيحة.',
            li1: 'تبدأ بالمقطع المطلوب من الدور السابق',
            li2: 'لا تنتهي بـ ん (n)',
            li3: 'موجودة في قائمة الكلمات المختارة',
            li4: 'لم تُلعب سابقًا في هذه المباراة',
            li5: 'تستخدم متجانسًا/صورة مسموحًا بها عندما تكون هذه القاعدة مفعّلة',
            p4: 'كل لعب صحيح يضع صورته على اللوحة بالترتيب، من اليسار إلى اليمين ومن الأعلى إلى الأسفل. e|مثال:_そば_→_バス|',
        },
        turnFlow: {
            title: 'الأدوار والتوقيت',
            p1: 'تنتقل الأدوار عبر قائمة اللاعبين؛ وعندما يصبح دورك لديك حتى 10 ثوانٍ من لحظة ظهور دورك.',
            p2: 'ينتظر Shiritori حتى يصبح اللاعب التالي نشطًا (المتصفح في الواجهة) قبل بدء العد التنازلي، ما يمنع تجاوز المؤقّت عبر إعادة التشغيل أو التحديث.',
            p3: 'أدخل كلمتك، راقب التحقق المباشر، وأرسل قبل انتهاء الوقت. الإرسال المتأخر أو غير الصحيح ينهي المباراة فورًا.',
        },
        boardFlow: {
            title: 'اللوحة، سير اللعب، والنهاية',
            p1: 'تعرض اللوحة كل كلمة لُعبت مع صورتها واسم اللاعب ورقم الدور، مع أسهم تتبع الترتيب عبر الشبكة.',
            p2: 'عندما يكون دور لاعب آخر، يمكنك أيضًا رؤية المقطع المطلوب للبدء والعد التنازلي أثناء الانتظار.',
            p3: 'إذا امتلأت كل الخانات بكلمات صحيحة، تنتهي اللعبة بنجاح وتعرض اللوحة المكتملة للمشاركة.',
            p4: 'إذا لم تُرسل أي حركة صحيحة قبل انتهاء المؤقّت، تنتهي اللعبة بملخص يوضح من انتهى وقته أو لعب كلمة غير صحيحة.',
        },
        summary: {
            title: 'الخلاصة',
            p1: 'تجعل Shiritori لعبة shiritori سريعة وبصرية: جولات قصيرة، قواعد واضحة، وتلميحات صورية تساعد الجميع على استمرار السلسلة.',
            p2: 'شارك رابطًا، املأ اللوحة، وانظر إلى أي مدى يمكن أن تستمر سلسلة كلماتك.',
        }
    },
    bugsAndFeatures: {
        title: 'تقارير الأخطاء والميزات الجديدة',
        p1: 'بنينا هذه اللعبة كطريقة مختلفة للعب اللعبة الكلاسيكية k|しりとり.| وبصفتنا فريقًا يحب الألعاب، فنحن دائمًا نبحث عن طرق لتحسينها وجعلها أكثر متعة.',
        cta: {
            l1: 'في الواقع، سنسعد كثيرًا إذا ساعدتنا عبر ',
            a: 'مشاركة لعبتنا مع أصدقائك',
            l2: ' على وسائل التواصل الاجتماعي!'
        },
        p2: 'إذا واجهت أي خطأ أو لديك اقتراحات لميزات جديدة، فأخبرنا!',
        bugs: {
            title: 'الأخطاء',
            p1: 'يرجى الإبلاغ عن أي سلوك غريب أو أخطاء مباشرة في مستودعنا العام على a|https://github.com/indexinteractive/|GitHub| . احرص على تضمين أكبر قدر ممكن من التفاصيل، بما في ذلك خطوات إعادة الإنتاج.'
        },
        features: {
            title: 'ميزات جديدة',
            p1: 'إذا كانت لديك اقتراحات لميزات جديدة أو تحسينات أو أفكار للعبة، فأخبرنا بإنشاء نقاش جديد في صفحة a|https://github.com/indexinteractive/|GitHub_Discussions| .'
        }
    },
    share: {
        title: 'Shiritori | تعلّم مفردات اليابانية عبر الإنترنت بسهولة مع لعبة しらとり الممتعة - SHIRITORI',
        text: 'العب Shiritori عبر الإنترنت مع أصدقائك أو لاعبين عشوائيين. لا حاجة للتسجيل!',
    }
};
